import { render, staticRenderFns } from "./Nieuws.vue?vue&type=template&id=fbce87dc"
import script from "./Nieuws.vue?vue&type=script&lang=js"
export * from "./Nieuws.vue?vue&type=script&lang=js"
import style0 from "./Nieuws.vue?vue&type=style&index=0&id=fbce87dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports